import _implicitStylesheets from "./moreDetails.css";
import _implicitScopedStylesheets from "./moreDetails.scoped.css?scoped=true";
import _wdsCompatibility from "wds/compatibility";
import _listingAppDetails from "listing/appDetails";
import _listingSecurityDetails from "listing/securityDetails";
import _wdsAdditionalDetails from "wds/additionalDetails";
import _listingSupportDetails from "listing/supportDetails";
import _listingMoreResources from "listing/moreResources";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="divider${0}"${2}></div>`;
const $fragment2 = parseFragment`<div class="divider${0}"${2}></div>`;
const stc0 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "size": "1:1@small 1:4@large"
  },
  key: 1
};
const stc1 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "size": "1:1@small 1:4@large"
  },
  key: 5
};
const stc2 = {
  attrs: {
    "grid": "",
    "axis": "row",
    "flow": "wrap",
    "gap": "x-large",
    "row-gap": "x-large"
  },
  key: 9
};
const stc3 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "size": "1:1@small 1:3@large"
  },
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, st: api_static_fragment} = $api;
  return [api_element("div", {
    attrs: {
      "grid": "",
      "axis": "row",
      "flow": "wrap",
      "gap": "x-large",
      "row-gap": "x-large",
      "data-scroll-to": "additional-details",
      "data-dummy": $cmp.scrollToParam
    },
    key: 0
  }, [api_element("div", stc0, [api_custom_element("wds-compatibility", _wdsCompatibility, {
    props: {
      "compatibilityProps": $cmp.compatibilitySummary
    },
    key: 2
  })]), api_element("div", {
    attrs: {
      "grid": "",
      "axis": "column",
      "size": $cmp.appDetailsColumnSize
    },
    key: 3
  }, [api_custom_element("listing-app-details", _listingAppDetails, {
    props: {
      "listing": $cmp.listing
    },
    key: 4
  })]), api_element("div", stc1, [api_custom_element("listing-security-details", _listingSecurityDetails, {
    props: {
      "listing": $cmp.listing
    },
    key: 6
  })])]), $cmp.additionalDetails ? api_static_fragment($fragment1, 8) : null, $cmp.additionalDetails ? api_element("div", stc2, [api_element("div", {
    attrs: {
      "grid": "",
      "axis": "column",
      "size": $cmp.additionalDetailsColumnSize
    },
    key: 10
  }, [api_custom_element("wds-additional-details", _wdsAdditionalDetails, {
    props: {
      "title": $cmp.i18n.heading.additionalDetails,
      "details": $cmp.additionalDetails
    },
    key: 11
  })]), $cmp.shouldDisplaySupportInfo ? api_element("div", stc3, [api_custom_element("listing-support-details", _listingSupportDetails, {
    props: {
      "listing": $cmp.listing
    },
    key: 13
  })]) : null]) : null, api_static_fragment($fragment2, 15), $cmp.displayMoreResources ? api_custom_element("listing-more-resources", _listingMoreResources, {
    props: {
      "title": $cmp.i18n.heading.moreResources,
      "resources": $cmp.moreResources
    },
    key: 16
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5uh55h6veim";
tmpl.legacyStylesheetToken = "undefined-_moreDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
